<div class="online-help-sidenav" [class.open]="opened">
    <div class="text-center position-relative mb-2">
        <h4>Guida in linea</h4>
        <mat-icon class="online-help-menu-icon" aria-hidden="false" aria-label="double_arrow_icon"
            fontIcon="keyboard_double_arrow_right" (click)="toggleOnlineHelpSidenav()"></mat-icon>
    </div>
    <div class="online-help-box">
        <ng-container *ngIf="selectedMap">
            <header>
                <h1>{{ selectedMap.headerTitle }}</h1>
                <p>{{ selectedMap.headerDescription }}</p>
            </header>
            <ng-container *ngIf="selectedMap.sections && selectedMap.sections.length > 0">
                <main>
                    <ng-container *ngFor="let section of selectedMap.sections">
                        <section>
                            <h4>{{ section.sectionTitle }}</h4>
                            <ng-container *ngFor="let description of section.sectionDescription">
                                <p [innerHTML]="description"></p>
                            </ng-container>
                        </section>
                    </ng-container>
                </main>
            </ng-container>
        </ng-container>
    </div>
</div>